var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contract"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9397 4.00058L19.0097 7.07058C19.7987 7.85961 20.25 8.93869 20.25 10.0802V17.0103C20.25 18.3398 19.8101 19.3895 19.0947 20.1049C18.3793 20.8203 17.3296 21.2603 16 21.2603H8C6.67044 21.2603 5.62075 20.8203 4.90533 20.1049C4.18991 19.3895 3.75 18.3398 3.75 17.0103V7.01025C3.75 5.68069 4.18991 4.631 4.90533 3.91558C5.62075 3.20017 6.67044 2.76025 8 2.76025H12.93C14.0635 2.76025 15.142 3.20291 15.9397 4.00058Z",
    stroke: "#202124",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1699 11.8258L8.00156 14.0003L10.1699 16.1748",
    stroke: "#202124",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.8301 16.1747L15.9984 14.0002L13.8301 11.8257",
    stroke: "#202124",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractIcon);
export default __webpack_public_path__ + "static/media/contract-icon.89086967e3f8e0265708780ca80ddb6e.svg";
export { ForwardRef as ReactComponent };